'use es6';

import isEmpty from 'hs-lodash/isEmpty';
import { OrderedMap } from 'immutable';
import { PropertyObjectTypes, PropertyObjectTypesIds } from 'FormsCommonComponents/constants/PropertyObjectTypes';
import { isContactProperty, isTicketProperty } from 'FormsCommonComponents/utils/PropertyObjectTypes';
import { EmailField } from 'FormsCommonComponents/constants/FormFields';
const getMatchProperty = (propertyObjectType, name) => f => f.name === name && f.propertyObjectType === propertyObjectType;
const getNotMatchProperty = (propertyObjectType, name) => f => !(f.name === name && f.propertyObjectType === propertyObjectType);
const getFieldsFromDependentFieldFilters = (dependentFieldFilters, group) => dependentFieldFilters.filter(({
  dependentFormField
}) => !isEmpty(dependentFormField)).map(({
  dependentFormField
}) => [dependentFormField.getIdentifier(), {
  dependentFormField,
  isDependent: true,
  group
}]);
const getFieldsFromField = (field, group, withDependent) => [[field.getIdentifier(), {
  field,
  isDependent: false,
  group
}], ...(withDependent ? getFieldsFromDependentFieldFilters(field.dependentFieldFilters, group) : [])];
const getAllFieldsFromGroup = (group, withDependent) => group.fields.reduce((innerAccum, field) => [/* eslint-disable-next-line hubspot-dev/no-reduce-accumulator-copy */
...innerAccum, ...getFieldsFromField(field, group, withDependent)], []);
export const getFieldsFromForm = (groups = [], options = {}) => {
  const {
    withDependent = true,
    withProgressive = true
  } = options;
  const shouldIncludeGroup = group => (withProgressive || group.default) && group.fields.length > 0;
  return new OrderedMap(groups.reduce((accum, group) => [/* eslint-disable-next-line hubspot-dev/no-reduce-accumulator-copy */
  ...accum, ...(shouldIncludeGroup(group) ? getAllFieldsFromGroup(group, withDependent) : [])], []));
};
export const getFormFieldById = (fields, id) => {
  return fields.get(id) ? fields.get(id).field : null;
};
export const removeFormFieldById = (groups, id) => {
  const [propertyObjectType, name] = id.split('-');
  const notMatchProperty = getNotMatchProperty(propertyObjectType, name);
  let updatedFormFieldGroups = [];
  groups.forEach(formFieldGroup => {
    const updatedFields = formFieldGroup.fields.filter(notMatchProperty);
    const updatedFormFieldGroup = Object.assign({}, formFieldGroup, {
      fields: updatedFields
    });
    if (updatedFields.length > 0) {
      updatedFormFieldGroups = [...updatedFormFieldGroups, updatedFormFieldGroup];
    }
  });
  return updatedFormFieldGroups;
};
export const updateFormField = (groups, updatedFormField) => {
  const propertyObjectType = updatedFormField.getPropertyObjectType();
  const name = updatedFormField.getPropertyName();
  const matchProperty = getMatchProperty(propertyObjectType, name);
  let updatedFormFieldGroups = [];
  groups.forEach(formFieldGroup => {
    const updatedFields = formFieldGroup.fields.map(formField => matchProperty(formField) ? updatedFormField : formField);
    const updatedFormFieldGroup = Object.assign({}, formFieldGroup, {
      fields: updatedFields
    });
    updatedFormFieldGroups = [...updatedFormFieldGroups, updatedFormFieldGroup];
  });
  return updatedFormFieldGroups;
};
export const getFormFieldGroupByFieldId = (groups, fieldId) => {
  let foundGroup = null;
  groups.forEach(formFieldGroup => {
    formFieldGroup.fields.forEach(field => {
      if (field.getIdentifier() === fieldId) {
        foundGroup = formFieldGroup;
      }
    });
  });
  return foundGroup;
};
export const hasMultipleFieldsPerGroup = groups => {
  if (groups.length) {
    for (let i = 0; i < groups.length; i++) {
      if (groups[i].fields.length > 1) {
        return true;
      }
    }
  }
  return false;
};
export const hasMaxOneFieldPerGroup = groups => {
  if (groups.length) {
    for (let i = 0; i < groups.length; i++) {
      if (groups[i].fields.length > 1) {
        return false;
      }
    }
  }
  return true;
};
export const getIsFieldRequiredByDefault = (name = '', objectTypeId = '') => name === EmailField && isContactProperty(objectTypeId);
export const getObjectTypeIdValue = (objectTypeId, propertyObjectType) => objectTypeId || PropertyObjectTypesIds[PropertyObjectTypes[propertyObjectType]] || PropertyObjectTypesIds[PropertyObjectTypes.CONTACT];
export const getPropertyObjectTypeForBackwardsCompatability = objectTypeId => {
  if (isTicketProperty(objectTypeId)) {
    return PropertyObjectTypes.TICKET;
  }
  return PropertyObjectTypes.CONTACT;
};
export const getObjectTypeLabel = (objectTypeLabel, objectTypeId) => {
  if (objectTypeLabel) {
    return objectTypeLabel;
  }
  if (isTicketProperty(objectTypeId)) {
    return PropertyObjectTypes.TICKET.toLowerCase();
  }
  return PropertyObjectTypes.CONTACT.toLowerCase();
};